/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalMessageType, BadRequestHandler } from '@spartacus/core';

const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';

@Injectable({
  providedIn: 'root',
})
export class CustomBadRequestHandler extends BadRequestHandler {
  protected override handleBadPassword(request: HttpRequest<any>, response: HttpErrorResponse): void {
    if (
      response.url?.includes(OAUTH_ENDPOINT) &&
      response.error?.error === 'invalid_grant' &&
      request.body?.get('grant_type') === 'password' &&
      response.error?.error_description === 'password.expired'
    ) {
      this.getFirstLoginMessage(response);
    } else if (
      response.url?.includes(OAUTH_ENDPOINT) &&
      response.error?.error === 'invalid_grant' &&
      request.body?.get('grant_type') === 'password' &&
      response.error?.error_description === 'b2bunit.all.disabled'
    ) {
      this.globalMessageService.add(
        { key: 'httpHandlers.b2bUnitAllDisabled' },
        GlobalMessageType.MSG_TYPE_ERROR,
      );
    } else {
      super.handleBadPassword(request, response);
    }
  }

  getFirstLoginMessage(response: HttpErrorResponse) {
    this.globalMessageService.add(
      {
        key: this.getErrorTranslationKey(response.error?.error_description),
        params: {
          errorMessage: response.error.error_description || response.message || '',
        },
      },
      GlobalMessageType.MSG_TYPE_WARNING,
    );
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
  }
}
